import React, { useState } from "react";

import img5 from '../assets/img/02-2025/5_0.png';
import img6 from '../assets/img/02-2025/6_0.png';
import img7 from '../assets/img/02-2025/7_0.png';
import img8 from '../assets/img/02-2025/8_0.png';

import sornUp from '../assets/img/icon/sorn-up.svg';

export default function Select4(border) {

    const [dataS, setDataS] = useState(null);
    return (
        <>
            <div className="mb-4">
                <div className="row justify-content-center text-start">
                    <div className="col-6 col-md-3 col-lg-3">
                        <button className="btn text-center" onClick={e => setDataS(1)}>
                            <img src={img5} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Objectives</h4>
                        </button>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <button className="btn text-center" onClick={e => setDataS(2)}>
                            <img src={img6} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Participants</h4>
                        </button>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <a href="https://drive.google.com/file/d/1RFQIs09hxvdgDfpXd8uP8B68N5weZ6iP/view?usp=drive_link" target={"_blank"} className="btn text-center">
                            <img src={img7} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Programme</h4>
                        </a>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <a href="https://drive.google.com/file/d/1eLVn_8dz8fAQjKfYKSi2OzsRXb5F0JdR/view?usp=drive_link" target={"_blank"} className="btn text-center">
                            <img src={img8} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Document</h4>
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div className="d-none d-md-block">
                    <div className="row text-start" style={{ marginBottom: "-20px" }}>
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                            {dataS === 1 && <img src={sornUp} className="" style={{ width: "50px", filter: "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)" }} />}
                        </div>
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                            {dataS === 2 && <img src={sornUp} className="" style={{ width: "50px", filter: "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)" }} />}
                        </div>
                    </div>
                </div>
                {dataS === 1 ?
                    <div className="p-4" style={{ background: "#FFDE59", borderRadius: "15px" }}>
                        <ol>
                            <li>To provide knowledge and better understand of Sufficiency Economy Philosophy for sustainability (SEPs) to participants of SEAMEO member countries </li>
                            <li>To motivate school principals/directors to promote the integration of SEP for school lifestyles </li>
                            <li>To develop a model for teaching and learning approach through SEP based analytical thinking </li>
                            <li>To share lesson learnt from models among schools and communities of SEAMEO member countries</li>
                        </ol>
                    </div>
                    : dataS === 2 ?

                        <div className="p-4" style={{ background: "#FFDE59", borderRadius: "15px" }}>
                            <p>School principals/directors and teachers in <b>lower secondary level</b> (G7 – G9) from SEAMEO Member Countries comprising: </p>
                            <br/>
                            <p><b>Phase 1:</b> 110 pax comprising 55 principals/directors and 55 teachers (5 schools/country)</p>
                            <p><b>Phase 2:</b> 22 pax comprising 1 principal/director and 1 teacher (1 school/country)</p>
                            <p><b>Phase 3:</b> Participants are from phase 2.</p>
                        </div>

                        : null}
            </div>

        </>
    );
}